import { TAction, TActionRequest } from "../../base/types/redux";
import {
  FilterEkycRequest,
  FilterEkycResponse,
  ApiStateType,
  ImportEkycRequest,
  ApiImportEkycStateType,
  SendEmailEkycResultRequest,
  FilterHealthCheckResponse,
  FilterOptionsResponse,
  ConfirmBatchHealthCheckRequest,
  SendEmailBatchHealthCheckRequest,
  GetPersonalHealthCheckDetailsRequest,
  ConfirmHealthCheckRequest,
  SendEmailHealthCheckRequest
} from "../utils/types";
import { ACTION_TYPES } from "./actionTypes";

export const filterEkyc = (params: FilterEkycRequest): TActionRequest<FilterEkycRequest> => {
  return {
    type: ACTION_TYPES.FILTER_EKYC,
    params,
  };
};

export const setFilterEkycState = (response: ApiStateType): TAction => {
  return {
    type: ACTION_TYPES.SET_FILTER_EKYC_STATE,
    response,
  };
};

export const setEkycList = (response: FilterEkycResponse): TAction => {
  return {
    type: ACTION_TYPES.SET_EKYC_LIST,
    response,
  };
};

export const downloadEkycList = (params: FilterEkycRequest): TActionRequest<FilterEkycRequest> => {
  return {
    type: ACTION_TYPES.DOWNLOAD_EKYC_LIST,
    params,
  };
};

export const setDownloadEkycListState = (response: ApiStateType): TAction => {
  return {
    type: ACTION_TYPES.SET_DOWNLOAD_EKYC_LIST_STATE,
    response,
  };
};

export const importEkyc = (params: ImportEkycRequest): TActionRequest<ImportEkycRequest> => {
  return {
    type: ACTION_TYPES.IMPORT_EKYC,
    params,
  };
};

export const setImportEkycState = (response: ApiImportEkycStateType): TAction => {
  return {
    type: ACTION_TYPES.SET_IMPORT_EKYC_STATE,
    response,
  };
};

export const sendEmailEkycResult = (params: SendEmailEkycResultRequest): TActionRequest<SendEmailEkycResultRequest> => {
  return {
    type: ACTION_TYPES.SEND_EMAIL_EKYC_RESULT,
    params,
  };
};

export const setSendEmailEkycResultState = (response: ApiStateType): TAction => {
  return {
    type: ACTION_TYPES.SET_SEND_EMAIL_EKYC_RESULT_STATE,
    response,
  };
};

export const filterHealthCheck = (params: FilterEkycRequest): TActionRequest<FilterEkycRequest> => {
  return {
    type: ACTION_TYPES.FILTER_HEALTH_CHECK,
    params,
  };
};

export const setFilterHealthCheckState = (response: ApiStateType): TAction => {
  return {
    type: ACTION_TYPES.SET_FILTER_HEALTH_CHECK_STATE,
    response,
  };
};

export const setHealthCheckList = (response: FilterHealthCheckResponse): TAction => {
  return {
    type: ACTION_TYPES.SET_HEALTH_CHECK_LIST,
    response,
  };
};

export const getFilterOptions = (): TActionRequest<null> => {
  return {
    type: ACTION_TYPES.GET_FILTER_OPTIONS,
    // params,
  };
};

export const setFilterOptions = (response: FilterOptionsResponse): TAction => {
  return {
    type: ACTION_TYPES.SET_FILTER_OPTIONS,
    response,
  };
};

export const confirmBatchHealthCheck = (params: ConfirmBatchHealthCheckRequest): TActionRequest<ConfirmBatchHealthCheckRequest> => {
  return {
    type: ACTION_TYPES.CONFIRM_BATCH_HEALTH_CHECK,
    params
  };
};

export const setConfirmBatchHealthCheckState = (response: ApiStateType): TAction => {
  return {
    type: ACTION_TYPES.SET_CONFIRM_BATCH_HEALTH_CHECK_STATE,
    response,
  };
};

export const sendEmailBatchHealthCheck = (params: SendEmailBatchHealthCheckRequest): TActionRequest<SendEmailBatchHealthCheckRequest> => {
  return {
    type: ACTION_TYPES.SEND_EMAIL_BATCH_HEALTH_CHECK,
    params
  };
};

export const setSendEmailBatchHealthCheckState = (response: ApiStateType): TAction => {
  return {
    type: ACTION_TYPES.SET_SEND_EMAIL_BATCH_HEALTH_CHECK_STATE,
    response,
  };
};

export const getPersonalHealthCheckDetails = (params: GetPersonalHealthCheckDetailsRequest): TActionRequest<GetPersonalHealthCheckDetailsRequest> => {
  return {
    type: ACTION_TYPES.GET_PERSONAL_HEALTH_CHECK_DETAILS,
    params,
  };
};

export const setPersonalHealthCheckDetails = (response: any): TAction => {
  return {
    type: ACTION_TYPES.SET_PERSONAL_HEALTH_CHECK_DETAILS,
    response,
  };
};

export const confirmHealthCheck = (params: ConfirmHealthCheckRequest): TActionRequest<ConfirmHealthCheckRequest> => {
  return {
    type: ACTION_TYPES.CONFIRM_HEALTH_CHECK,
    params,
  };
};

export const setConfirmHealthCheckState = (response: ApiStateType): TAction => {
  return {
    type: ACTION_TYPES.SET_CONFIRM_HEALTH_CHECK_STATE,
    response,
  };
};

export const getDetails = (params: GetPersonalHealthCheckDetailsRequest): TActionRequest<GetPersonalHealthCheckDetailsRequest> => {
  return {
    type: ACTION_TYPES.GET_DETAILS,
    params,
  };
};

export const setDetails = (response: any): TAction => {
  return {
    type: ACTION_TYPES.SET_DETAILS,
    response,
  };
};
export const exportPdfDetails = (params: GetPersonalHealthCheckDetailsRequest): TActionRequest<GetPersonalHealthCheckDetailsRequest> => {
  return {
    type: ACTION_TYPES.EXPORT_PDF_DETAILS,
    params,
  };
};

export const sendEmailHealthCheck = (params: SendEmailHealthCheckRequest): TActionRequest<SendEmailHealthCheckRequest> => {
  return {
    type: ACTION_TYPES.SEND_EMAIL_HEALTH_CHECK,
    params
  };
};

export const setSendEmailHealthCheckState = (response: ApiStateType): TAction => {
  return {
    type: ACTION_TYPES.SET_SEND_EMAIL_HEALTH_CHECK_STATE,
    response,
  };
};

export const getFilterEkycOptions = (): TActionRequest<null> => {
  return {
    type: ACTION_TYPES.GET_FILTER_EKYC_OPTIONS,
    // params,
  };
};

export const setFilterEkycOptions = (response: FilterOptionsResponse): TAction => {
  return {
    type: ACTION_TYPES.SET_FILTER_EKYC_OPTIONS,
    response,
  };
};

